interface LoadingSkeletonProps {
  className?: string;
}

export default function LoadingSkeleton({ className = 'h-40 w-full' }: LoadingSkeletonProps) {
  return <div className={`bg-deep animate-pulse rounded ${className}`} />;
}
